module.exports = {"casino":{"je_ne_possede_pas_encore_de_compte":"I don't have an account yet","demande_de_sav_refusees":"Denied service request","numero_de_demande":"Request number","date_demande":"Request date","date_d_achat":"Purchase date","ean":"EAN","commentaire":"Comment","justificatif_d_achat":"Proof of purchase","plaque_signaletique":"Type plate","modifier":"Modify","supprimer":"Delete"}}


//////////////////
// WEBPACK FOOTER
// ./src/companies/casino/lang/en/home/home.lang.json
// module id = p0QM
// module chunks = 1